<template>
  <div class="container" id="boxLabelManage">
    <el-dialog
      ref="historyBoxDialog"
      title="历史箱子标签"
      :visible.sync="historyBoxDialogVisible"
      center
      width="95%"
      top="10vh"
      @opened="openedPrintDialog"
      @closed="closedPrintDialog">
      <el-form @submit.native.prevent inline :rules="printRules" :model="printForm" ref="refPrintForm">
        <el-form-item label="箱号:">
          <el-input
            ref="refBoxNo"
            autocomplete="off"
            clearable
            maxlength="50"
            v-model.trim="printForm.trackingNo"
            @keyup.enter.native="handleEnterTrackingNo"
            @clear="clearTrackingNo"
            tabindex="1">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loadingPrint"
            type="primary"
            @click="submitPrintForm">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="table"
        max-height="500px"
        :data="historyBoxList"
        :cell-style="{background: '#0E1C3B', 'padding': '5px 0', fontSize: '13px', textAlign: 'center', color: 'white'}"
        :header-cell-style="{background: '#0E1C3B', padding: '5px 0', fontSize: '13px', textAlign: 'center', color: 'white'}"
        row-key="id"
        border
        @expand-change="expandChange">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.caseInfo"
                      border
                      :cell-style="{background: '#0E1C3B', padding: '5px 0', fontSize: '13px', textAlign: 'center', color: 'white'}"
                      :header-cell-style="{background: '#0E1C3B', padding: '5px 0', fontSize: '13px', textAlign: 'center', color: 'white'}">
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <el-table :data="scope.row.labelDetails"
                            border
                            :header-cell-style="{background: '#0E1C3B', padding: '5px 0', textAlign: 'center', fontSize: '13px', color: 'white'}"
                            :cell-style="{background: '#0E1C3B', padding: '5px 0', textAlign: 'center', fontSize: '13px', color: 'white'}">
                    <el-table-column label="订单子批号" width="250">
                      <template slot-scope="props">
                        {{subNoVal(props.row.incoOrdersDetail)}}
                      </template>
                    </el-table-column>
                    <el-table-column label="印章号" width="250">
                      <template slot-scope="props">
                        {{lotNoVal(props.row.incoOrdersDetail)}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="count" label="实际数量" width="120"/>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column label="盒号" width="250">
                <template slot-scope="scope">
                  {{scope.row.trackingNo}}
                </template>
              </el-table-column>
              <el-table-column prop="partNo" label="PARTNO" width="150"/>
              <el-table-column prop="packageType" label="封装名称" width="150"/>
              <el-table-column prop="lotNo" label="印章号" width="200"/>
              <el-table-column prop="qty" label="实际数量" width="120"/>
              <el-table-column v-if="!props.row.result" prop="explain" label="失效原因" width="150"/>
              <el-table-column label="更新时间" width="140">
                <template slot-scope="scope">
                  {{formatDate(scope.row.updateAt)}}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="medium"
                    type="text"
                    @click="reprint(scope.row)">
                    重新打印
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="箱号">
          <template slot-scope="scope">
            {{scope.row.trackingNo}}
          </template>
        </el-table-column>
        <el-table-column prop="partNo" label="PARTNO" width="150"/>
        <el-table-column prop="packageType" label="封装名称" width="150"/>
        <el-table-column prop="lotNo" label="印章号" width="200"/>
        <el-table-column prop="qty" label="实际数量" width="120"/>
        <el-table-column prop="binLevel" label="档位" width="80"/>
        <el-table-column
          label="净重"
          width="120">
          <template slot-scope="scope">
            <el-input
              ref="refNetWeight"
              v-if="editIndex === scope.$index"
              clearable
              v-model.trim="scope.row.netWeight"
              autocomplete="on"
              type="text"
              maxlength="10">
            </el-input>
            <span v-else>{{scope.row.netWeight === null || scope.row.netWeight === undefined ? '' : scope.row.netWeight + 'kg'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="毛重"
          width="120">
          <template slot-scope="scope">
            <el-input
              ref="refGrossWeight"
              v-if="editIndex === scope.$index"
              clearable
              v-model.trim="scope.row.grossWeight"
              autocomplete="on"
              type="text"
              maxlength="10">
            </el-input>
            <span v-else>{{scope.row.grossWeight === null || scope.row.grossWeight === undefined ? '' : scope.row.grossWeight + 'kg'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="120">
          <template slot-scope="scope">
            {{formatDate(scope.row.updateAt)}}
          </template>
        </el-table-column>
        <el-table-column prop="result" label="结果" width="90">
          <template slot-scope="scope">
            {{scope.row.result ? 'PASSED' : 'FAILED'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteClick(scope.row)" class="link">
              删除
            </el-button>
            <span class="separator"/>
            <el-button
              :disabled="disabledUpdate(scope.row, scope.$index)"
              type="text"
              @click="updateBox(scope.row, scope.$index)"
              class="link">
              {{editIndex === scope.$index ? '确定' : '修改'}}
            </el-button>
            <span class="separator"/>
            <el-button
              :disabled="editIndex === scope.$index"
              type="text"
              @click="print(scope.row)"
              class="link">
              打印
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="totalCount"
        :pageSize="perpage"
        :current-page.sync="page"
        @current-change="onChangePage"
      />
    </el-dialog>
    <el-form @submit.native.prevent class="form" :inline="true" :model="boxLabelManageForm" :rules="rules"
             ref="refBoxLabelManageForm">
      <el-form-item label="请扫描要装箱的盒子标签:" prop="trackingNo">
        <el-tooltip
          v-model="isShowBigChar"
          placement="bottom-start"
          effect="dark"
          content="大写锁定已打开"
          manual>
          <el-input
            ref="refTrayNo"
            autocomplete="off"
            clearable
            maxlength="50"
            v-model="boxLabelManageForm.trackingNo"
            @keyup.enter.native="handleEnter"
            @keypress.native="onKeyPress">
          </el-input>
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="false" prop="printWeight" label="箱标包含重量信息:">
        <el-radio-group v-model="boxLabelManageForm.printWeight">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">
          添加
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="labelList"
              style="margin: 40px auto; width: 80%;"
              :cell-style="{background: '#0E1C3B', 'padding': '5px 5px 5px 0', fontSize: '13px', textAlign: 'center', color: 'white'}"
              :header-cell-style="{background: '#0E1C3B', textAlign: 'center', color: 'white'}">
      <el-table-column width="100">
        <template slot-scope="scope">
          {{scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column
        prop="trackingNo"
        label="盒子标签">
      </el-table-column>
      <el-table-column
        prop="productName"
        label="产品型号"
        width="150">
      </el-table-column>
      <el-table-column prop="packageType" label="封装名称" width="150"/>
      <el-table-column
        prop="qty"
        label="数量"
        width="120">
      </el-table-column>
      <el-table-column
        prop="binLevel"
        label="档位"
        width="80">
      </el-table-column>
      <el-table-column
        prop="result"
        label="结果"
        width="120">
        <template slot-scope="scope">
          {{scope.row.result ? 'PASSED' : 'FAILED'}}
        </template>
      </el-table-column>
      <el-table-column key="mixed" v-if="!isFailedBox" label="允许混装" prop="isMixed" width="90">
        <template slot-scope="scope">
          {{scope.row.isMixed ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column key="explain" v-if="isFailedBox" label="失效原因" prop="explain" width="120">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope" width="90">
          <el-button type="text" @click="deleteLabelClick(scope.$index)" class="link">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;">
      <el-button
        type="plain"
        @click="showHistoryDialog">
        历史箱标
      </el-button>
      <el-button
        :loading="loadingMain"
        type="primary"
        @click="createBox"
        :disabled="labelList && labelList.length === 0">
        打印箱标
      </el-button>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';
  import {generateBinLevelValue, printLabel} from '@/utils/label';
  import {getLabel} from '@/api/label';
  import {
    createBox,
    boxListGet,
    deleteBox,
    boxDetailGet,
    updateBox,
  } from '@/api/boxLabel';
  import {isNum} from '@/utils';
  import pagination from './pagination';

  export default {
    components: {
      pagination,
    },
    data() {
      let validateTrackingNo = (rule, value, callback) => {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          this.boxLabelManageForm.trackingNo = '';
          callback(new Error('盒子标签不能为空'));
          return;
        }
        if (!(/^[A-Za-z0-9/$#@-]+$/.test(value))) {
          this.boxLabelManageForm.trackingNo = '';
          callback(new Error(`${value}标签格式错误`));
          return;
        }
        callback();
      };
      return {
        rules: {
          trackingNo: [{required: true, validator: validateTrackingNo, trigger: 'submit'}],
          printWeight: [{required: true, message: '箱标包含重量信息不能为空', trigger: 'submit'}],
        },
        boxLabelManageForm: {
          trackingNo: '',
          printWeight: true,
        },
        printRules: {},
        printForm: {
          trackingNo: undefined,
        },
        searchParams: {
          trackingNo: undefined,
        },
        loadingPrint: false,
        loadingMain: false,
        labelList: [],
        totalCount: 0,
        page: 1,
        perpage: 13,
        historyBoxDialogVisible: false,
        historyBoxList: [],
        expands: [],
        editIndex: -1,
        isShowBigChar: false,
        isFailedBox: false,
      }
    },
    mounted() {
      this.$refs.refTrayNo && this.$refs.refTrayNo.focus();
      this.scanBoxInfoBarCode();
    },
    methods: {
      async expandChange(row) {
        const {
          id,
          caseInfo,
        } = row;
        const findIndex = this.historyBoxList.findIndex(item => item.id === id);
        if (findIndex === -1 || caseInfo) {
          return;
        }
        try {
          let param = {boxLabelId: id};
          const res = await boxDetailGet(param);
          const data = res.data;
          const caseInfo = data.info;
          Vue.set(this.historyBoxList[findIndex], 'caseInfo', caseInfo);
        } catch (e) {
        }
      },
      handleEnter() {
        this.submitForm();
      },
      scanBoxInfoBarCode() {
        let code = '';
        let nextCode;
        document.onkeypress = (e) => {
          nextCode = e.which;
          if (this.loadingMain) {
            return;
          }
          if (nextCode !== 13) {
            code += String.fromCharCode(nextCode);
          }
          if (nextCode === 13) {
            if (this.historyBoxDialogVisible) {
              if (this.loadingPrint) {
              } else if (this.$refs.refBoxNo && this.$refs.refBoxNo.focused) {
              } else {
                this.printForm.trackingNo = code;
                this.submitPrintForm();
              }
            } else if (this.loadingMain) {
            } else if (this.$refs.refTrayNo && this.$refs.refTrayNo.focused) {
            } else if (this.labelList.length >= 10) {
              this.$message({
                type: 'error',
                message: '最多只能将10个盒子装入箱子'
              })
            } else {
              this.boxLabelManageForm.trackingNo = code;
              this.submitForm();
            }
            code = '';
          }
        };
      },
      handleEnterTrackingNo() {
        this.submitPrintForm();
      },
      clearTrackingNo() {
        this.submitPrintForm();
      },
      submitPrintForm() {
        this.$refs.refPrintForm.validate(async (valid) => {
          if (valid) {
            this.page = 1;
            this.historyBoxList = [];
            this.searchParams = {...this.printForm};
            this.boxListGet();
          }
        });
      },
      submitForm() {
        this.$refs.refBoxLabelManageForm.validate(async (valid) => {
          if (valid) {
            this.addLabelClick();
          }
        });
      },
      async addLabelClick() {
        if (this.labelList && this.labelList.length >= 10) {
          return;
        }
        let trackingNo = this.boxLabelManageForm.trackingNo;
        if (typeof trackingNo === 'string') {
          trackingNo = trackingNo.trim();
        }
        this.boxLabelManageForm.trackingNo = '';
        let findIndex = this.labelList.findIndex(item => item.trackingNo === trackingNo);
        if (findIndex === -1) {
          try {
            const res = await getLabel({
              trackingNo: trackingNo,
              page: 1,
              perpage: 10
            });
            const data = res.data, info = data.info;
            if (data.count === 1) {
              const {
                productName,
                chipName,
                partNo,
                lotNo,
                qty,
                trackingNo,
                dateCode,
                packageType,
                result,
                boxLabelId,
                labelDetails,
                binLevel,
                id,
                explain,
                isMixed,
              } = info[0];
              if (boxLabelId === null) {
                findIndex = this.labelList.findIndex(item => item.trackingNo === trackingNo);
                let findProdNoIndex = this.labelList.findIndex(item => item.productName !== productName || item.chipName !== chipName || item.partNo !== partNo);
                let findPackageNoIndex = this.labelList.findIndex(item => item.packageType !== packageType);
                let findResultIndex = this.labelList.findIndex(item => item.result !== result);
                if (findProdNoIndex !== -1) {
                  this.$message({
                    message: '不同产品型号芯片不能混装',
                    type: 'error'
                  });
                  return;
                }
                if (findPackageNoIndex !== -1) {
                  this.$message({
                    message: '不同封装形式芯片不能混装',
                    type: 'error'
                  });
                  return;
                }
                if (findResultIndex !== -1) {
                  this.$message({
                    message: '不同结果芯片不能混装',
                    type: 'error'
                  });
                  return;
                }
                this.isFailedBox = !result;
                if (findIndex !== -1) {
                  return;
                }
                let subNo;
                if (labelDetails && labelDetails.length === 1) {
                  subNo = labelDetails[0].subNo;
                  if (isMixed) {
                    let findIsNotMixedIndex = this.labelList.findIndex(item => item.isMixed === false);
                    if (findIsNotMixedIndex !== -1) {
                      this.$message({
                        message: '存在不允许混装的盒子',
                        type: 'error'
                      });
                      return;
                    }
                  } else {
                    let findIndex = this.labelList.findIndex(item => item.subNo !== subNo);
                    if (findIndex !== -1) {
                      this.$message({
                        message: '该盒子不允许混装',
                        type: 'error'
                      });
                      return;
                    }
                  }
                } else if (labelDetails && labelDetails.length >= 2) {
                  let findIsNotMixedIndex = this.labelList.findIndex(item => item.isMixed === false);
                  if (findIsNotMixedIndex !== -1) {
                    this.$message({
                      message: '存在不允许混装的盒子',
                      type: 'error'
                    });
                    return;
                  }
                }
                let findBinLevelIndex = this.labelList.findIndex(item => item.binLevel !== binLevel);
                if (findBinLevelIndex !== -1) {
                  this.$message({
                    message: '档位不一致不能装箱',
                    type: 'error'
                  });
                  return;
                }
                this.labelList.unshift({
                  productName,
                  chipName,
                  partNo,
                  lotNo,
                  qty,
                  trackingNo,
                  dateCode,
                  packageType,
                  result,
                  subNo,
                  isMixed: isMixed === 1,
                  binLevel,
                  id,
                  explain,
                });
                if (this.labelList.length === 10) {
                  this.createBox();
                }
              } else {
                this.$message({
                  message: '该盒已经装入其他箱子',
                  type: 'error'
                });
              }
            } else {
              this.$message({
                message: '标签有误，请检查标签',
                type: 'error'
              });
            }
          } catch (e) {
          } finally {
          }
        } else {
          this.$message({
            message: '盒标签重复',
            type: 'error'
          });
        }
      },
      deleteLabelClick(index) {
        this.labelList.splice(index, 1);
      },
      async createBox() {
        this.loadingMain = true;
        try {
          const labelIds = [];
          let binLevel, productName, chipName;
          for (let row of this.labelList) {
            binLevel = row.binLevel;
            productName = row.productName;
            chipName = row.chipName;
            if (row.id) {
              labelIds.push(row.id);
            }
          }
          const res = await createBox({
            labelIds: JSON.stringify(labelIds),
            isPrintWeight: this.boxLabelManageForm.printWeight,
          });
          const data = res.data;
          this.boxLabelManageForm.trackingNo = '';
          this.labelList = [];
          let binLevelValue = generateBinLevelValue({productName, chipName, binLevel});
          printLabel({...data, binLevelExplain: binLevelValue});
        } catch (e) {
          // do nothing.
        } finally {
          this.loadingMain = false;
        }
      },
      print(row) {
        const {
          partNo,
          chipName,
          binLevel,
        } = row;
        let binLevelValue = generateBinLevelValue({partNo, chipName, binLevel});
        printLabel({...row, binLevelExplain: binLevelValue});
      },
      reprint(row) {
        const {
          productName,
          chipName,
          binLevel,
        } = row;
        let binLevelValue = generateBinLevelValue({productName, chipName, binLevel});
        printLabel({...row, binLevelExplain: binLevelValue});
      },
      showHistoryDialog() {
        this.historyBoxDialogVisible = true;
        this.boxListGet();
        this.editIndex = -1;
      },
      onChangePage() {
        this.boxListGet();
      },
      async boxListGet() {
        try {
          this.loadingPrint = true;
          let param = {page: this.page, perpage: this.perpage, trackingNo: this.searchParams.trackingNo || undefined,};
          const res = await boxListGet(param);
          const data = res.data;
          if (data.count !== undefined) {
            this.totalCount = data.count;
          }
          this.historyBoxList = data.info;
        } catch (e) {
        } finally {
          this.loadingPrint = false;
        }
      },
      deleteClick(row) {
        this.$confirm('此操作将永久删除该箱子标签, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteBox(row);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      async deleteBox(row) {
        try {
          await deleteBox({boxLabelIds: [row.id]});
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          if (this.historyBoxList.length === 1 && this.page > 1) {
            this.page = this.page - 1;
          }
          this.boxListGet(this.page, this.perpage);
        } catch (e) {
        }
      },
      formatDate(updateAt) {
        let updateDate = moment.utc(updateAt);
        let isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
        if (isSameYear) {
          return updateDate.local().format("MM/DD HH:mm");
        } else {
          return updateDate.local().format("YYYY/MM/DD HH:mm");
        }
      },
      async updateBox(row, index) {
        const editIndex = this.editIndex;
        if (editIndex === -1) {
          this.editIndex = index;
          setTimeout(() => {
            this.$refs.refNetWeight && this.$refs.refNetWeight.focus();
          });
          this.$refs.table && this.$refs.table.toggleRowExpansion(row, true);
        } else {
          const {
            id,
            grossWeight,
            netWeight,
          } = row;
          if (!this.validateNetWeight(netWeight)) {
            return;
          }
          if (!this.validateGrossWeight(grossWeight)) {
            return;
          }
          this.$refs.table && this.$refs.table.toggleRowExpansion(row, false);
          try {
            await updateBox({
              boxLabelId: id,
              grossWeight: Number.parseFloat(grossWeight),
              netWeight: Number.parseFloat(netWeight),
            });
            this.$message({
              type: 'success',
              message: '更改成功'
            });
            this.editIndex = -1;
            this.boxListGet(this.page, this.perpage);
          } catch (e) {
            // do nothing.
          }
        }
      },
      disabledUpdate(row, index) {
        const editIndex = this.editIndex;
        const {
          netWeight,
          grossWeight,
        } = row;
        return editIndex !== -1 && index !== editIndex || netWeight === null || netWeight === undefined
          || grossWeight === null || grossWeight === undefined;
      },
      validateNetWeight(value) {
        const isEmptyValue = value === undefined || value === '';
        if (isEmptyValue) {
          this.$message({
            type: 'error',
            message: '净重不能为空'
          });
          return false;
        }
        if (!isNum(value)) {
          this.$message({
            type: 'error',
            message: '净重必须是数值类型'
          });
          return false;
        }
        if (!(/^(-?\d+)(\.\d{1,2})?$/.test(value))) {
          this.$message({
            type: 'error',
            message: '净重最多有两位小数'
          });
          return false;
        }
        if (Number.parseFloat(value) <= 0) {
          this.$message({
            type: 'error',
            message: '净重必须大于0'
          });
          return false;
        }
        return true;
      },
      validateGrossWeight(value) {
        const isEmptyValue = value === undefined || value === '';
        if (isEmptyValue) {
          this.$message({
            type: 'error',
            message: '毛重不能为空'
          });
          return false;
        }
        if (!isNum(value)) {
          this.$message({
            type: 'error',
            message: '毛重必须是数值类型'
          });
          return false;
        }
        if (!(/^(-?\d+)(\.\d{1,2})?$/.test(value))) {
          this.$message({
            type: 'error',
            message: '毛重最多有两位小数'
          });
          return false;
        }
        if (Number.parseFloat(value) <= 0) {
          this.$message({
            type: 'error',
            message: '毛重必须大于0'
          });
          return false;
        }
        return true;
      },
      openedPrintDialog() {
        this.$refs.refBoxNo && this.$refs.refBoxNo.focus();
      },
      closedPrintDialog() {
        this.printForm.trackingNo = undefined;
        this.$refs.refPrintForm && this.$refs.refPrintForm.clearValidate();
        this.$refs.refTrayNo && this.$refs.refTrayNo.focus();
        this.historyBoxList = [];
      },
      onKeyPress(event) {
        let e = event || window.event;
        let keyCode = e.keyCode || e.which;
        let isShift = e.shiftKey || keyCode === 16 || false; //shift键是否按住
        if (((keyCode >= 65 && keyCode <= 90) && !isShift)
          || ((keyCode >= 97 && keyCode <= 122) && isShift)) {
          this.isShowBigChar = true;
        } else {
          this.isShowBigChar = false;
        }
      },
      subNoVal(incoOrdersDetail) {
        if (!incoOrdersDetail) {
          return '';
        }
        return incoOrdersDetail.subNo;
      },
      lotNoVal(incoOrdersDetail) {
        if (!incoOrdersDetail) {
          return '';
        }
        return incoOrdersDetail.lotNo;
      }
    },
  };
</script>
<style lang="less" scoped>
  .container {
    text-align: center;
  }

  .form {
    margin-top: 40px;
  }

  .separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 2px;
    vertical-align: middle;
    background: #409EFF;
  }

</style>
